
import {
  appointmentsModule,
  installationsModule,
  commonModule,
  statsModule,
  dashboardModule,
  companyModule,
} from "@/store/modules/store-accessor";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  calcDuration,
  appointmentStatusToColor,
  appointmentStatusToName,
  formatDateWithoutSeconds,
  getOptimalTextColor,
  mergedAddressAndArea,
  canceledAppointmentValues,
} from "../../helpers/data";
import { openInstallationSideview } from "@/helpers/installationSideview";

@Component
export default class DashboardTodaysAppointmentsTable extends Vue {
  @Prop() readonly headers: any;
  @Prop() readonly items: any;
  @Prop() readonly search: string;
  @Prop() readonly isLoading: boolean;

  setStatusColor(status: string) {
    return appointmentStatusToColor(status);
  }

  setStatusText(status: string) {
    return appointmentStatusToName(status);
  }

  setDuration(start: Date, end: Date) {
    return calcDuration(start, end);
  }

  setScheduledStart(scheduled_start: Date) {
    return formatDateWithoutSeconds(scheduled_start);
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  isRecurringAppointment(appointment: Record<string, any>) {
    return this.companyHasAdvancedPlan && appointment.recurrence_id != null;
  }

  get companyHasAdvancedPlan() {
    return companyModule.company?.modules?.includes('DFB_ADVANCED_PLAN');
  }

  setMergedAddressAndArea(address: string, area: string) {
    return mergedAddressAndArea(address, area);
  }

  async openInstallationSideView(appointment: any) {
    try {
      dashboardModule.setIsLoadingAppointmentsList(true);
      await openInstallationSideview({
        installationId: appointment.installation_id,
        tab: 'appointments',
        appointmentId: appointment.id,
        recurrenceId: appointment.recurrence_id,
      });
    } catch (error) {
      // Sideview open failed (e.g. installation deleted).
    } finally {
      dashboardModule.setIsLoadingAppointmentsList(false);
    }
  }

  canceledAppointmentValues(item: Record<string, any>) {
    return canceledAppointmentValues(item);
  }

}
